import { FormKeys } from '.';

export interface FormFields {
    [FormKeys.PackName]: string;
    [FormKeys.Description]: string;
    [FormKeys.LabelName]: string;
    [FormKeys.PackGenre]: string;
    [FormKeys.PackSubgenre]: string;
    [FormKeys.Exclusivity]: string;
    [FormKeys.Lexicon]: string;
}
